module.exports = __webpack_public_path__ + "files/f4ff90770d5af2dcc8106cc98cd235cd.png";